import React from "react";
import { pointsConfig } from "../../../../pointsConfig";

function MilesRankDetailBadgesSection() {
  const badges = [
    {
      icon: pointsConfig.badges.person.active,
      label: "Verified Partner",
    },
    {
      icon: pointsConfig.badges.rocket.active,
      label: "First Sale",
    },
    {
      icon: pointsConfig.badges.star.active,
      label: "Daily Dealer",
    },
    {
      icon: pointsConfig.badges.flight.active,
      label: "Flight Pro",
    },
    {
      icon: pointsConfig.badges.hotel.active,
      label: "Hotel Hero",
    },
    {
      icon: pointsConfig.badges.tour.active,
      label: "Tour Specialist",
    },
  ];

  return (
    <div className="flex flex-col w-full mt-6">
      <span className="font-BrFirmaBold text-lg mb-2">Badges</span>
      <div className="flex gap-4 flex-wrap w-full justify-between">
        {badges.map((badge, index) => (
          <div
            key={index}
            className="flex w-[48%] h-28 rounded-xl items-center gap-2 border border-black/10 p-4 bg-white"
          >
            <img src={badge.icon} alt="" className="w-20 object-contain" />
            <span className="">{badge.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
}

export default MilesRankDetailBadgesSection;
